import svc from "../../services/api/UserService";
import {CurrentUser} from "../../services/CurrentUser";
import {getProducts} from "../product/productAction";

const namespace = "user";

export const GET_USER_DETAILS_SUCCESS = `${namespace}/GET_USER_DETAILS_SUCCESS`;
export const GET_USER_DETAILS_FAIL = `${namespace}/GET_USER_DETAILS_FAIL`;

export function startSession() {
    return dispatch => {
        dispatch({ type: GET_USER_DETAILS_SUCCESS, user: {
                id: CurrentUser.userId,
                fullName: CurrentUser.fullName,
                initials: CurrentUser.initials,
                customerName: CurrentUser.customerName,
                customerId: CurrentUser.customerId,
                allClaims: CurrentUser.allClaims
            }});
        dispatch(getProducts());
    };
}

export function getCurrentPlatformUserDetails() {
    return (dispatch) => {
        return svc.platformUserDetails
            .then((result) => {dispatch({ type: GET_USER_DETAILS_SUCCESS, user: result.user});
            })
            .catch(() => dispatch({ type: GET_USER_DETAILS_FAIL}));
    };
}


